// extracted by mini-css-extract-plugin
export default {"about":"About_about__g896u","content":"About_content__ZpYIu"};